// @ts-ignore
import $ from 'jquery';
export var initProSetting = function (column) {
    column.getElement().querySelectorAll('.ac-column-setting--pro').forEach(function (setting) {
        setting.querySelectorAll('input').forEach(function (input) {
            input.addEventListener('click', function () { return $(setting).find('[data-ac-modal]').trigger('click'); });
        });
    });
};
